<template>
    <div class="flex align-bottom mt-1">
        <div class="mx-2 text-center" v-for="number in max" :key="number">
            <label
                class="-m-0.5 relative p-0.5 rounded-full flex items-center justify-center cursor-pointer focus:outline-none ring-indigo-500"
            >
                <input
                    type="radio"
                    :name="name"
                    @change="onChange($event)"
                    :value="number"
                    class="sr-only"
                    aria-labelledby="color-choice-1-label"
                />
                <span
                    aria-hidden="true"
                    class="h-4 w-4 border border-black border-opacity-10 rounded-full"
                    :class="number <= modelValue ? 'bg-indigo-400' : 'bg-gray-200'"
                ></span>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSmallNumberRangeInput',
    emits: ['update:modelValue'],
    props: {
        max: {
            required: true,
            type: Number,
        },
        name: {
            required: true,
            type: String,
        },
        modelValue: {
            required: true,
        },
    },
    methods: {
        onChange(event) {
            this.$emit('update:modelValue', event.target.value);
        },
    },
};
</script>
